import { render, staticRenderFns } from "./ChallengeActions.vue?vue&type=template&id=2896a86e&scoped=true"
import script from "./ChallengeActions.vue?vue&type=script&lang=ts"
export * from "./ChallengeActions.vue?vue&type=script&lang=ts"
import style0 from "./ChallengeActions.vue?vue&type=style&index=0&id=2896a86e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2896a86e",
  null
  
)

export default component.exports